import { Injectable } from '@angular/core';
import { defineSafIcon } from '@saffron/web-components';
import { defineOnvioToast } from '@onviobr/components';
@Injectable({
	providedIn: 'root',
})
export class OnvioDesignComponentesService {
	constructor() { }
	public defineOnvioDesignComponents(): void {
		defineSafIcon();
		defineOnvioToast();
	}
}
